﻿import { getItemTypeName } from '../../metadata/itemType';

const getRelshipItem = (stateData, state) => {
	const { selectedId } = state;
	return stateData.get(selectedId);
};

const getRelatedItem = (stateData, state) => {
	const { related_id: relatedId } = getRelshipItem(stateData, state);
	return stateData.get(relatedId);
};

const getAccessValue = (stateData, state) => {
	const relshipItem = getRelshipItem(stateData, state);
	const { 'role@aras.keyed_name': label } = relshipItem;
	return { label };
};

const getMultiLingualValue = (stateData, state, property) => {
	const { languages } = state;
	const relatedItem = getRelatedItem(stateData, state);
	return languages.reduce((result, { code }) => {
		result[code] = relatedItem[`${property}@aras.lang.${code}`];
		return result;
	}, {});
};

const getImageValue = (stateData, state) => {
	const { image } = getRelatedItem(stateData, state);
	return image;
};

const getItemTypeValue = (stateData, state) => {
	const relatedItem = getRelatedItem(stateData, state);
	const { additional_data: additionalData } = relatedItem;
	const { itemTypeId } = additionalData;
	const label = getItemTypeName(itemTypeId);
	return { label };
};

const propertyValueGenerators = {
	access: getAccessValue,
	label: (...args) => getMultiLingualValue(...args, 'label'),
	image: getImageValue,
	itemType: getItemTypeValue
};

export const getFormValues = (stateData, state, order) => {
	return order.reduce((result, property) => {
		const value = propertyValueGenerators[property](stateData, state);
		result[property] = value;
		return result;
	}, {});
};
